import React, { useState } from "react";
import { useHover } from "./HoverContext";
import { Breadcrumb } from "./Breadcrumb";
import { InspectorPanel } from "../InspectorPanel/InspectorPanel";
import { moveNodeOnDrop } from "./moveNodeOnDrop";

import { SectionRenderer } from "./Renderer/SectionRenderer";
export function moveNodeAction(sourceId, targetId,setPage) {
  setPage(prev => moveNodeOnDrop(prev, sourceId, targetId));
}


export function HoverLabel({ id }) {
  const { hoverNodeId } = useHover();
  if (hoverNodeId !== id) return null;

  const type = id.startsWith("el-")
    ? "Element"
    : id.startsWith("crd-")
    ? "Card"
    : id.startsWith("con-")
    ? "Container"
    : "Section";

  return (
    <span
      style={{
        position: "absolute",
        top: "-30px",
        right: 0,
        background: "#1A73E8",
        color: "#fff",
        fontSize: 10,
        padding: "2px 4px",
        borderRadius: 3,
        pointerEvents: "none",
        
      }}
    >
      {type}
    </span>
  );
}




export function PageRenderer({ page, setPage }) {
  return (
    <div>
      
       <Breadcrumb page={page} />
      {page.sections.map((section) => (
        <SectionRenderer
          key={section?.id}
          section={section}
          page={page}
          setPage={setPage}
        />
      ))}
      <InspectorPanel page={page} setPage={setPage} />
      <style>{`.node-actions {
  display: flex;
  gap: 4px;
  position: absolute;
  top: -26px;
  right: 0;
  opacity: 0;
  background: white;
  border-radius: 4px;
  padding: 2px 4px;
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
  z-index: 10;
  transition: opacity 0.15s ease;
}

.node-wrapper:hover .node-actions,
.selected .node-actions {
  opacity: 1;
}

.node-actions button {
  font-size: 10px;
  padding: 2px 4px;
  cursor: pointer;
}

.drag-btn {
  cursor: grab !important;
}

.drag-btn:active {
  cursor: grabbing !important;
}
`}</style>
    </div>
  );
}
